export function commaSeparateItems(itemIndex: number, arrayLength: number) {
    return itemIndex < arrayLength - 1 ? ',' : '';
}

export function showQuantityIfMoreThanOne(itemQuantity: number, itemName: string) {
    return `${itemQuantity > 1 ? `${itemQuantity}x` : ''} ${itemName}`;
}
